import * as Cesium from 'cesium';
import { DATA_SOURCES } from '../config/dataSources';

export interface TerrainLoadResult {
  provider: Cesium.TerrainProvider;
  isFallback: boolean;
}

function configureWaterAppearance(viewer: Cesium.Viewer): void {
  const globe = viewer.scene.globe;
  globe.showWaterEffect = true;
  globe.oceanNormalMapUrl = '/cesiumStatic/Assets/Textures/waterNormals.jpg';
  globe.baseColor = Cesium.Color.fromBytes(17, 72, 91, 255);
}

export async function loadBaseTerrain(
  viewer: Cesium.Viewer,
  onError: (error: unknown) => void,
): Promise<TerrainLoadResult> {
  try {
    const provider = await Cesium.CesiumTerrainProvider.fromUrl(
      DATA_SOURCES.terrain,
      {
        requestVertexNormals: true,
        requestWaterMask: true,
        requestMetadata: true,
        credit: 'PLATEAU-Terrain / 国土交通省',
      },
    );

    let fallbackApplied = false;
    provider.errorEvent.addEventListener((error) => {
      if (fallbackApplied) return;
      fallbackApplied = true;
      onError(error);
      viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
      configureWaterAppearance(viewer);
      viewer.scene.requestRender();
    });
    viewer.terrainProvider = provider;
    configureWaterAppearance(viewer);
    viewer.scene.requestRender();
    return { provider, isFallback: false };
  } catch (error) {
    onError(error);
    // 初期化時から存在するEllipsoidTerrainProviderをそのまま利用する。
    // Cesiumの地球表示は継続し、画面全体を停止させない。
    return { provider: viewer.terrainProvider, isFallback: true };
  }
}
